import * as React from 'react';
import { IButtonProps } from './IButton';

const Button = (props: IButtonProps) => {
    return (
        <div className={props.className}>
            <button type={props.type || 'button'} className={props.classNameBtn} disabled={props.disabled} onClick={props.onClick}>
                {props.children}
            </button>
        </div>
    );
};

export default Button;
